"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.zip = rxjs_1.zip;
//# sourceMappingURL=zip.js.map